module.exports = __webpack_public_path__ + "static/media/sample_lmsobzones.70c9d2c5.csv";